var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMedal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ri:medal-fill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.0026 9.33206C18.8316 9.33206 21.5447 10.4559 23.5451 12.4563C25.5455 14.4566 26.6693 17.1698 26.6693 19.9987C26.6693 22.8277 25.5455 25.5408 23.5451 27.5412C21.5447 29.5416 18.8316 30.6654 16.0026 30.6654C13.1736 30.6654 10.4605 29.5416 8.46013 27.5412C6.45974 25.5408 5.33594 22.8277 5.33594 19.9987C5.33594 17.1698 6.45974 14.4566 8.46013 12.4563C10.4605 10.4559 13.1736 9.33206 16.0026 9.33206ZM16.0026 13.9987L14.2399 17.5721L10.2959 18.1454L13.1493 20.9254L12.4759 24.8534L16.0026 22.9987L19.5293 24.8521L18.8559 20.9254L21.7093 18.1441L17.7653 17.5707L16.0026 13.9987ZM17.3359 2.66406L24.0026 2.6654V6.6654L22.1853 8.18273C20.6771 7.39197 19.0306 6.89942 17.3359 6.73206V2.66406ZM14.6693 2.66406V6.73073C12.9751 6.89826 11.329 7.3908 9.82127 8.1814L8.0026 6.6654V2.6654L14.6693 2.66406Z",
    fill: "url(#paint0_linear_4032_22142)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4032_22142",
    x1: 9.00293,
    y1: 9.49805,
    x2: 35.5029,
    y2: 43.998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B88C00"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedal);
export default __webpack_public_path__ + "static/media/medal.3209f89d4de06ca5a68dca22133c15e0.svg";
export { ForwardRef as ReactComponent };